<app-header></app-header>
<ion-content>
  <div *ngIf="!p.renderMobile" class="breadcrumb-margin">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ion-grid [ngClass]="{'display-none': showPageLoader}">
    <ion-row class="rental-details__container">
      <ion-col size="12" [sizeMd]="itemId ? 6 : 12">
        <ng-container *ngIf="canEdit; else userView">
          <app-card [title]="headerInit.title">
            <form [formGroup]="form" (ngSubmit)="onClickSave()">
              <app-input
                [form]="form"
                formControlName="name"
                label="NAME"
                [submittedError]="validationError"
              ></app-input>
              <app-input
                type="textarea"
                [form]="form"
                formControlName="description"
                label="DESCRIPTION"
                [submittedError]="validationError"
              ></app-input>

              <ion-item class="input" lines="none">
                <app-upload-attachment
                  [attachment]="item ? item?.image : ''"
                  (attachmentUploaded)="imageUploaded($event)"
                  (attachmentRemoved)="imageRemoved($event)"
                >
                </app-upload-attachment>
              </ion-item>
              <ion-label
                *ngIf="form.get('itemImage').hasError('fileMaxSize') && (form.get('itemImage').touched || validationError)"
                color="danger"
                class="font-size__16"
              >
                {{"MAX_SIZE_VALIDATION"|translate}}
              </ion-label>
              <ion-label
                *ngIf="form.get('itemImage').hasError('fileFormat')"
                color="danger"
                class="font-size__16"
              >
                <div>
                  {{ "FILE_TYPE_VALIDATION_1" | translate }}
                  "{{form.get('itemImage').errors.fileFormat.actualFormat}}". {{
                  "FILE_TYPE_VALIDATION_2" | translate }}
                </div>
              </ion-label>
              <div
                *ngIf="itemId; else addSave"
                class="rental-details__button-container"
              >
                <ng-container *appHasRole="['rental.edit']">
                  <ion-button
                    *ngIf="!p.renderMobile"
                    fill="outline"
                    color="primary"
                    (click)="deleteItem()"
                  >
                    {{ 'DELETE' | translate }}
                  </ion-button>
                </ng-container>

                <div
                  id="buttonDiv"
                  class="rental-details__button-container rental-details__button-container--inner"
                >
                  <ng-container *ngIf="itemId; else addSave">
                    <ion-button
                      *appHasRole="['rental.reservation.add'];"
                      (click)="onClickReservation()"
                    >
                      {{ 'RENTAL.RESERVATION' | translate }}
                    </ion-button>
                    <ion-button
                      type="submit"
                      size="medium"
                      slot="end"
                      [disabled]="disableSaveButton"
                    >
                      {{ (!disableSaveButton ? 'SAVE' : 'SAVING') | translate}}
                    </ion-button>
                  </ng-container>
                </div>
              </div>
              <ng-template #addSave>
                <div
                  class="rental-details__button-container flex-justify-content-flex-end"
                >
                  <div
                    class="rental-details__button-container rental-details__button-container--inner"
                  >
                    <ion-button
                      [ngClass]="{'margin-left-auto':!itemId}"
                      type="submit"
                      class="button-margin-top-md float-right"
                      size="medium"
                      slot="end"
                      [disabled]="disableSaveButton"
                    >
                      {{ (!disableSaveButton ? 'SAVE' : 'SAVING') | translate}}
                    </ion-button>
                  </div>
                </div>
              </ng-template>
            </form>
            <div *ngIf="itemId">
              <hr />
              <app-comment
                [comments]="item.comments"
                [id]="itemId"
                [tableName]="rentalServ.tableName"
                [refreshCommentsOnInit]="false"
                mode="comment"
                deletePermission="rental.comments.delete"
              ></app-comment>
            </div>
          </app-card>
        </ng-container>
        <ng-template #userView>
          <app-card [title]="item.name">
            <ion-grid>
              <ion-row>
                <ion-col size="12">
                  <app-status
                    [directionColumn]="false"
                    [color]="rentalServ.getStatusColor(item.rentalStatus)"
                    name="{{ 'RENTAL.STATUS.'+(item.rentalStatus) | translate}}"
                  >
                  </app-status>
                  <ion-label> {{item.description}} </ion-label>
                </ion-col>
                <ion-col
                  size-xs="12"
                  size-sm="6"
                  size-md="8"
                  size-lg="8"
                  size-xl="6"
                >
                  <ion-img
                    [src]="item.image !== null ? item.image.filePath : '../../../assets/icons/book-outline.svg'"
                    class="rental-details__image"
                  >
                  </ion-img>
                </ion-col>
              </ion-row>
              <ion-row *appHasRole="['rental.reservation.add']">
                <ion-col>
                  <ion-button (click)="onClickReservation()">
                    {{ 'RENTAL.RESERVATION' | translate }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
            <div *ngIf="itemId">
              <hr />
              <app-comment
                [comments]="item.comments"
                [id]="itemId"
                [tableName]="rentalServ.tableName"
                [refreshCommentsOnInit]="false"
                mode="comment"
                deletePermission="rental.comments.delete"
              ></app-comment>
            </div>
          </app-card>
        </ng-template>
      </ion-col>
      <ion-col
        class="rental-details__list-column"
        *ngIf="itemId"
        size="12"
        sizeMd="6"
      >
        <app-card [paddingZeroBreakpoint]="1200">
          <ion-list>
            <ion-list-header class="rental-details__list-header">
              {{ 'RENTAL.RESERVATIONS_AND_RENTALS' | translate }}
            </ion-list-header>
            <div class="rental-details__dropdown-container">
              <app-select-dropdown
                [data]="rentalStatusArray"
                [value]="rentalStatusArray[0]"
                (changeValueEvent)="onDropdownValueChanged($event)"
              >
              </app-select-dropdown>
            </div>
            <ng-container *ngIf="filteredItemRentals.length; else NoItems">
              <ion-card *ngFor="let item of filteredItemRentals">
                <ion-card-header>
                  <ion-grid>
                    <ion-row>
                      <ion-col size="9">
                        <ion-card-title>
                          <app-status
                            [directionColumn]="false"
                            [color]="rentalServ.getStatusColor(item.status)"
                            name="{{ 'RENTAL.STATUS.'+(item.status) | translate}}"
                          >
                          </app-status>
                        </ion-card-title>
                        <ion-card-subtitle>
                          <ion-label>
                            {{ 'RENTAL.CREATION_DATE' | translate }}:
                            {{item.dateCreated | dateSti}}
                          </ion-label>
                          <br />
                          <ion-label>
                            {{ 'USER' | translate }}: {{item.user.firstName}}
                            {{item.user.lastName}}
                          </ion-label>
                          <br />
                          <ion-label>
                            {{ 'RENTAL.COMPANY' | translate }}:
                            {{item.user.company.name}}
                          </ion-label>
                        </ion-card-subtitle>
                      </ion-col>
                      <ion-col size="3">
                        <app-avatar
                          [big]="width > 339"
                          [user]="item.user"
                          class="rental-details__avatar"
                        >
                        </app-avatar>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-card-header>
                <ion-card-content class="flex-beetwen">
                  <ng-container
                    *ngIf="(canEdit) || (userServ.userStorage.id === item.idUser && item.status === rentalStatus.Reservation)"
                  >
                    <ion-button
                      color="secondary"
                      size="small"
                      (click)="onClickDeleteItemRental(item.id)"
                    >
                      {{ 'DELETE' | translate }}
                    </ion-button>
                  </ng-container>
                  <div *ngIf="canEditStatus">
                    <ion-button
                      (click)="onClickChangeStatus(item.id, rentalStatus.Rent)"
                      *ngIf="item.status === rentalStatus.Reservation"
                      size="small"
                    >
                      {{ 'RENTAL.GIVE_OUT' | translate }}
                    </ion-button>
                    <ion-button
                      *ngIf="item.status === rentalStatus.Reservation"
                      size="small"
                      (click)="onClickNotify(item.id)"
                    >
                      {{ 'RENTAL.NOTIFICATION_OF_RECEIPT' | translate }}
                    </ion-button>
                    <ion-button
                      (click)="onClickChangeStatus(item.id, rentalStatus.Return)"
                      size="small"
                      *ngIf="item.status === rentalStatus.Rent"
                    >
                      {{ 'RENTAL.RETURN' | translate }}
                    </ion-button>
                  </div>
                </ion-card-content>
              </ion-card>
            </ng-container>
            <ng-template #NoItems>
              <span class="rental-details__no-rentals">
                <ion-label> {{ 'RENTAL.NO_RENTALS' | translate }} </ion-label>
              </span>
            </ng-template>
          </ion-list>
        </app-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-container *ngIf="showPageLoader">
    <app-loading-sti> </app-loading-sti>
  </ng-container>
</ion-content>
